
define('text!gameInterfaces/pages/PlayNGoGameInterface.html',[],function () { return '<div data-bind="compose: { model: realityCheckViewModel, view: \'features/realityCheck/realityCheck.html\' }">\n</div>\n';});

